import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, IconButton, Tooltip, Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { formatBRL } from '../../../UI';
import { TIPO_FORMA_PAGTO_CARTAO, TIPO_FORMA_PAGTO_DINHEIRO } from './passoTresController';

function labelFormaPagamento(idFormaPagamento, formasPagamentoOptions) {
  const opcao = formasPagamentoOptions.find(item => item.id === idFormaPagamento);
  return opcao ? opcao.value : idFormaPagamento;
}

/**
 * Tabela de parcelas do Passo 3 — port de `TableHeaderPassoTres.jsx`/
 * `TableBodyPassoTres.jsx`/`TableFooterPassoTres.jsx` reais combinados num só
 * componente. Ordenação por Vencimento via `TableSortLabel` (mesmo padrão da
 * Etapa 4) — a tela real não tem drag-and-drop, só ordenação por coluna.
 */
export default function TableParcelasPassoTres({
  parcelas, formasPagamentoOptions, formaPagamentoPasso2, ordenacaoAscendente, onClickColunaVencimento, onClickAlterar,
}) {
  const totalParcelas = parcelas.reduce((total, parcela) => total + parcela.valor, 0);

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Forma do Pagamento</TableCell>
          <TableCell>Nº Parcela</TableCell>
          <TableCell align="right">Valor</TableCell>
          <TableCell>
            <TableSortLabel
              active
              direction={ordenacaoAscendente ? 'asc' : 'desc'}
              onClick={onClickColunaVencimento}
            >
              Vencimento
            </TableSortLabel>
          </TableCell>
          <TableCell align="center">Ações</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {parcelas.map((parcela) => {
          const desabilitarEdicao = parcela.formaPagamento === TIPO_FORMA_PAGTO_CARTAO
            || (parcela.formaPagamento === TIPO_FORMA_PAGTO_DINHEIRO && formaPagamentoPasso2 === TIPO_FORMA_PAGTO_DINHEIRO);
          return (
            <TableRow key={parcela.nParcela} hover>
              <TableCell>{labelFormaPagamento(parcela.formaPagamento, formasPagamentoOptions)}</TableCell>
              <TableCell>{parcela.nParcela}</TableCell>
              <TableCell align="right">{formatBRL(parcela.valor)}</TableCell>
              <TableCell>{parcela.vencimento}</TableCell>
              <TableCell align="center">
                <Tooltip title="Alterar Parcela">
                  <span>
                    <IconButton
                      size="small"
                      disabled={desabilitarEdicao}
                      onClick={() => onClickAlterar(parcela)}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
      <tfoot>
        <TableRow>
          <TableCell colSpan={2} />
          <TableCell align="right">
            <Typography sx={{ fontWeight: 700 }}>{formatBRL(totalParcelas)}</Typography>
          </TableCell>
          <TableCell colSpan={2} />
        </TableRow>
      </tfoot>
    </Table>
  );
}

TableParcelasPassoTres.propTypes = {
  parcelas: PropTypes.array,
  formasPagamentoOptions: PropTypes.array,
  formaPagamentoPasso2: PropTypes.number,
  ordenacaoAscendente: PropTypes.bool.isRequired,
  onClickColunaVencimento: PropTypes.func.isRequired,
  onClickAlterar: PropTypes.func.isRequired,
};

TableParcelasPassoTres.defaultProps = {
  parcelas: [],
  formasPagamentoOptions: [],
  formaPagamentoPasso2: null,
};
